import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GET_PROPERTY_BY_SLUG } from "../api/constants";

export const useProperty = () => {
  const { slug } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!slug) return;

    const fetchProperty = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${GET_PROPERTY_BY_SLUG}${slug}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const data = await response.json();

        if (data.status) {
          setProperty(data.data);
        } else {
          setProperty(null);
          setError(data.message || "Property not found");
        }
      } catch (err) {
        console.error("Error fetching property:", err);
        setError("Failed to fetch property");
      } finally {
        setLoading(false);
      }
    };

    fetchProperty();
  }, [slug, token]);

  return { property, loading, error };
};
